<template>
	<div
		class="cobrowsing-action-button"
		@click="e => emit('click', e)"
	>
		<ButtonLoading
			v-if="isLoading != null"
			:isLoading="props.isLoading"
			:disabled="props.disabled"
			iconOnly
		>
			<i
				:class="props.iconClass"
				:style="props.iconStyle"
			/>
		</ButtonLoading>

		<button
			v-else
			:disabled="props.disabled"
		>
			<i
				:class="props.iconClass"
				:style="props.iconStyle"
			/>
		</button>

		<span>
			<slot></slot>
		</span>
	</div>
</template>
<script lang="ts">
	export interface ICoBrowsingToolbarButtonProps {
		disabled?: boolean;
		isLoading?: boolean;
		iconClass: string | string[] | { [key: string]: string };
		iconStyle?: string;
	}
</script>
<script setup lang="ts">
	import ButtonLoading from '@core/components/ButtonLoading.vue';

	const props = defineProps<ICoBrowsingToolbarButtonProps>();
	const emit = defineEmits(['click']);
</script>
<style scoped>
	.cobrowsing-action-button {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.cobrowsing-action-button:hover {
		color: var(--main-color);
	}

	.cobrowsing-action-button:has(button:disabled) {
		cursor: not-allowed;
		pointer-events: none;
		color: var(--disabled-color);
	}

	.cobrowsing-action-button button {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		width: 35px;
		height: 35px;
		margin: 5px;
		border-radius: 10px;
	}
</style>
